import React from "react";
import { Reveal } from "./Motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../config";

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative bg-[var(--bg-concrete)] text-[var(--text-dark)] py-24 md:py-36">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <Reveal>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[var(--accent)]">/ Pricing & Services</span>
            <h2 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter mt-4 leading-[0.9]">What we<br />haul away.</h2>
          </Reveal>
          <Reveal delay={0.1} className="max-w-sm">
            <p className="text-[#333] leading-relaxed">Transparent starting prices — final quote depends on volume and access. Get an exact bid in minutes by sending a photo.</p>
          </Reveal>
        </div>

        <div className="border-t-2 border-black">
          {SERVICES.map((s, i) => (
            <Reveal key={s.code} delay={i * 0.05}>
              <button
                data-testid={`service-row-${s.code}`}
                onClick={() => document.querySelector("#bid")?.scrollIntoView({ behavior: "smooth" })}
                className="group w-full text-left grid grid-cols-12 items-center gap-4 py-6 md:py-8 border-b border-black/20 hover:bg-black hover:text-[var(--bg-concrete)] transition-colors duration-300 px-2 md:px-4"
              >
                <span className="col-span-2 md:col-span-1 font-mono text-sm">{s.code}</span>
                <span className="col-span-10 md:col-span-4 font-display text-2xl md:text-4xl font-bold uppercase tracking-tight">{s.name}</span>
                <span className="col-span-8 md:col-span-4 text-sm text-[#555] group-hover:text-[var(--bg-concrete)]/70 hidden md:block">{s.desc}</span>
                <span className="col-span-3 md:col-span-2 font-mono text-base md:text-lg text-right md:text-left">{s.price}</span>
                <span className="col-span-1 flex justify-end"><ArrowUpRight className="opacity-40 group-hover:opacity-100 group-hover:text-[var(--accent)] transition-all group-hover:translate-x-1 group-hover:-translate-y-1" /></span>
              </button>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
